import { AxiosRequestConfig } from 'axios';
import {
  CreateDPIAResponse,
  DPIAFinishResult,
  DPIAUpdatePayload
} from '../types/DPIA.types';
import API from './ApiBase';
import { AIGenerateJobResponse } from '../types/AIJob.types';

type ApiRequestConfig = AxiosRequestConfig & { skipErrorToast?: boolean };

export const createDPIADraft = async (aiSystemId: string) => {
  const response = await API.post<CreateDPIAResponse>(
    `/dpia/ai-systems/${aiSystemId}`
  );
  return response.data;
};

export const getDPIAById = async (
  dpiaId: string,
  options?: { suppressErrorToast?: boolean }
) => {
  const config: ApiRequestConfig = {};

  if (options?.suppressErrorToast) {
    config.skipErrorToast = true;
  }
  const response = await API.get<CreateDPIAResponse>(`/dpia/${dpiaId}`, config);
  return response.data;
};

export const getDPIAByAiSystem = async (
  aiSystemId: string,
  options?: { suppressErrorToast?: boolean }
) => {
  const config: ApiRequestConfig = {};

  if (options?.suppressErrorToast) {
    config.skipErrorToast = true;
  }
  const response = await API.get<CreateDPIAResponse>(
    `/dpia/ai-systems/${aiSystemId}`,
    config
  );
  return response.data;
};

export const getDPIAByDocumentId = async (documentId: string) => {
  const response = await API.get<CreateDPIAResponse>(
    `/dpia/documents/${documentId}`
  );
  return response.data;
};

// Update DPIA (draft only)
export const updateDPIA = async (
  dpiaId: string,
  payload?: DPIAUpdatePayload
) => {
  const response = await API.put<CreateDPIAResponse>(
    `/dpia/${dpiaId}`,
    payload
  );
  return response.data;
};

// Complete DPIA
export const completeDPIA = async (
  dpiaId: string,
  payload?: DPIAUpdatePayload
) => {
  const response = await API.put<DPIAFinishResult>(
    `/dpia/${dpiaId}/complete`,
    payload
  );
  return response.data;
};

export const generateDPIAContent = async (
  dpiaId: string,
  forceRefresh: boolean = false,
  options?: { suppressErrorToast?: boolean }
): Promise<AIGenerateJobResponse> => {
  const config: ApiRequestConfig = {};

  if (options?.suppressErrorToast) {
    config.skipErrorToast = true;
  }

  const response = await API.post<AIGenerateJobResponse>(
    `/dpia/${dpiaId}/generate`,
    { forceRefresh },
    config
  );
  return response.data;
};
